export interface Contract {
  message: string;
}

export enum ContractType {
  fund = 'Fondsgebunden',
}
